<template>
  <el-dialog
    :title="dialog2.title" 
    :visible.sync="dialog2.show" 
    :close-on-click-modal="false"
    width="800px"
    @close="handleClose"
  >
    <el-form 
      ref="form" 
      :model="formData" 
      :rules="formRules" 
      label-width="120px" 
      size="small"
    >
      <!-- 房屋信息展示（只读） -->
      <el-card class="readonly-card" shadow="never">
        <div slot="header" class="card-header">
          <span class="header-title">
            <i class="el-icon-office-building"></i>
            房屋信息
          </span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">区域：</span>
              <span class="readonly-value">{{ getSafeValue(formData.houseInfo, 'address', '-') }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">房间号：</span>
              <span class="readonly-value">{{ getSafeValue(formData.houseInfo, 'roomNum', '-') }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">面积：</span>
              <span class="readonly-value">{{ getSafeValue(formData.houseInfo, 'roomSquare', '-') }}㎡</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 租户信息展示（只读） -->
      <el-card class="readonly-card" shadow="never">
        <div slot="header" class="card-header">
          <span class="header-title">
            <i class="el-icon-user"></i>
            租户信息
          </span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">公司名称：</span>
              <span class="readonly-value">{{ getSafeValue(formData.tenantInfo, 'tenantname', '-') }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">联系人：</span>
              <span class="readonly-value">{{ getSafeValue(formData.tenantInfo, 'contact', '-') }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="readonly-item">
              <span class="readonly-label">联系方式：</span>
              <span class="readonly-value">{{ getSafeValue(formData.tenantInfo, 'contactphone', '-') }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <el-divider></el-divider>
      
      <!-- 可编辑的租赁信息 -->
      <div class="edit-section-title">
        <i class="el-icon-edit"></i>
        租赁信息编辑
      </div>
      
      <!-- 开始日期和结束日期 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="开始日期：" prop="startdate">
            <el-date-picker
              v-model="formData.startdate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :editable="false"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="结束日期：" prop="enddate">
            <el-date-picker
              v-model="formData.enddate"
              type="date"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :editable="false"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 租金信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="租金：" prop="currentrentalamount">
            <el-input
              v-model="formData.currentrentalamount"
              placeholder="请输入租金"
              type="number"
              min="0"
              step="0.01"
              :controls="false"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="押金：" prop="deposit">
            <el-input
              v-model="formData.deposit"
              placeholder="请输入押金"
              type="number"
              min="0"
              step="0.01"
              :controls="false"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 支付信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="欠款金额：" prop="arrears">
            <el-input
              v-model="formData.arrears"
              placeholder="请输入欠款金额"
              type="number"
              min="0"
              step="0.01"
              :controls="false"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="是否付清：" prop="isfullypaid">
            <el-select v-model="formData.isfullypaid" placeholder="请选择" style="width: 100%;">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 其他信息 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="下次交租日：" prop="nextrentpaydate">
            <el-date-picker
              v-model="formData.nextrentpaydate"
              type="date"
              placeholder="选择下次交租日"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 备注 -->
      <el-form-item label="备注：" prop="remarks">
        <el-input
          v-model="formData.remarks"
          type="textroomSquare"
          :rows="3"
          placeholder="请输入备注信息"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      
      <!-- 隐藏字段 -->
      <el-input v-if="formData.leaseid" v-model="formData.leaseid" type="hidden"></el-input>
      <el-input v-if="getSafeValue(formData.houseInfo, 'houseid')" v-model="formData.houseInfo.houseid" type="hidden"></el-input>
      <el-input v-if="getSafeValue(formData.tenantInfo, 'tenantid')" v-model="formData.tenantInfo.tenantid" type="hidden"></el-input>
    </el-form>
    
    <div slot="footer" class="dialog2-footer">
      <el-button @click="dialog2.show = false" size="small">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" size="small" :loading="loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import leaseApi from '../api/leaseinfo.js'

export default {
  name: "LeaseinfoEditdialog2",
  props: {
    dialog2: {
      type: Object,
      default: () => ({
        show: false,
        title: ""
      })
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      formRules: {
        startdate: [
          { required: true, message: '请选择开始日期', trigger: 'blur' }
        ],
        enddate: [
          { required: true, message: '请选择结束日期', trigger: 'blur' }
        ],
        currentrentalamount: [
          { required: true, message: '请输入租金', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式' }
        ],
        arrears: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式' }
        ],
        deposit: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式' }
        ],
        isfullypaid: [
          { required: true, message: '请选择是否付清', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    'dialog2.show'(val) {
      if (val) {
        // 确保数据完整性
        this.ensureDataIntegrity();
      }
    }
  },
  methods: {
    // 安全获取嵌套属性值
    getSafeValue(obj, key, defaultValue = '') {
      if (!obj || !key) return defaultValue;
      const keys = key.split('.');
      let result = obj;
      
      for (const k of keys) {
        if (result === null || result === undefined || typeof result !== 'object') {
          return defaultValue;
        }
        result = result[k];
      }
      
      return result !== undefined && result !== null ? result : defaultValue;
    },
    
    ensureDataIntegrity() {
      // 确保嵌套对象存在
      this.formData.houseInfo = this.formData.houseInfo || { 
        address: '', 
        roomNum: '', 
        roomSquare: '',
        houseid: ''
      };
      this.formData.tenantInfo = this.formData.tenantInfo || { 
        tenantname: '', 
        contact: '', 
        contactphone: '',
        tenantid: ''
      };
      
      // 确保其他字段存在
      this.formData.startdate = this.formData.startdate || '';
      this.formData.enddate = this.formData.enddate || '';
      this.formData.currentrentalamount = this.formData.currentrentalamount || 0;
      this.formData.arrears = this.formData.arrears || 0;
      this.formData.deposit = this.formData.deposit || 0;
      this.formData.isfullypaid = this.formData.isfullypaid || '否';
      this.formData.nextrentpaydate = this.formData.nextrentpaydate || '';
      this.formData.contractno = this.formData.contractno || '';
      this.formData.remarks = this.formData.remarks || '';
    },
    
    handleClose() {
      this.$refs.form.resetFields();
    },
    
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 准备提交数据
          const submitData = {
            leaseid: this.formData.leaseid,
            startdate: this.formData.startdate,
            enddate: this.formData.enddate,
            currentrentalamount: this.formData.currentrentalamount,
            arrears: this.formData.arrears,
            deposit: this.formData.deposit,
            isfullypaid: this.formData.isfullypaid,
            nextrentpaydate: this.formData.nextrentpaydate,
            contractno: this.formData.contractno,
            remarks: this.formData.remarks,
            // 只传递ID，不传递整个对象
            houseid: this.getSafeValue(this.formData.houseInfo, 'houseid'),
            tenantid: this.getSafeValue(this.formData.tenantInfo, 'tenantid')
          };
          
          leaseApi.updateleaseinfo(submitData).then(res => {
            if (res.data.flag === true) {
              this.$message.success('修改成功');
              this.dialog2.show = false;
              this.$emit('update');
            } else {
              this.$message.error(res.data.msg || '修改失败');
            }
            this.loading = false;
          }).catch(error => {
            console.error('修改失败:', error);
            this.$message.error('修改失败，请检查网络连接');
            this.loading = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped>
/* 只读卡片样式 */
.readonly-card {
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.card-header {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

.header-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.header-title i {
  margin-right: 8px;
  color: #409EFF;
}

.readonly-card .el-card__body {
  padding: 16px;
}

/* 只读项目样式 */
.readonly-item {
  padding: 8px 0;
  line-height: 1.6;
}

.readonly-label {
  color: #606266;
  font-weight: 500;
  display: inline-block;
  width: 70px;
  text-align: right;
  margin-right: 8px;
}

.readonly-value {
  color: #303133;
  font-weight: 500;
  background-color: #f9f9f9;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  min-width: 100px;
  border: 1px solid #e4e7ed;
}

/* 编辑区域标题 */
.edit-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #409EFF;
  display: flex;
  align-items: center;
}

.edit-section-title i {
  margin-right: 8px;
  color: #409EFF;
}

/* 表单样式调整 */
.el-form-item {
  margin-bottom: 16px;
}

.el-divider {
  margin: 20px 0;
}

/* 对话框底部 */
.dialog2-footer {
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}
</style>